import React from 'react';

const UpdateText = ({
    type = '',
    classes = '',
    inputProps = {},
    krData = false,
    onChangeText
}) => {
    const __classNames = [
        ('wobo-text-field'),
        (inputProps.disabled ? 'disabled' : null),
        (type || null),
        (classes || null)
    ]
        .filter(name => name)
        .join(' ');
    return (
        <>
            <span className="sr-only"> &nbsp; </span>
            <input
                type="text"
                className={__classNames}
                data-testid="wobo-text-field"
                {...inputProps}
                onChange={(e) => onChangeText(e)}
            />
        </>
    )
}

export default UpdateText;
